import { Icon } from '../c-mp/comp/Icon'
import { $when, Show } from '../c-mp/comp/Show'
import { Slot } from '../c-mp/comp/Slot'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { andrisEmail } from '../fun/andrisEmail'
import { formatNumber } from '../fun/formatNumber'
import { getAverageFirstMarriageAge } from '../fun/getAverageFirstMarriageAge'
import { appState } from '../model/appState'
import { _ } from '../model/ccc'
import { MAX_AGE } from '../model/MAX_AGE'

export const FooterComp = defineComponent<{}>('FooterComp', (props, $) => {
	return (
		<footer class='ccc_footer'>
			<div class={_.ccc_narrow}>
				<Show
					debugName='Van adat'
					it={$when(
						() => appState.data,
						({ get: getData }) => (
							<>
								<p>
									A Parditka családfa{' '}
									<b>
										<a href='/person/1951-02-08-Parditka-Tamás'>
											Parditka Tamás
										</a>
									</b>{' '}
									gyűjtése, a Percze családfa{' '}
									<b>
										<a href='/person/1952-11-02-Hegymegi-Ilona-Magdolna'>
											Lazsánné Hegymegi Ilona
										</a>
									</b>{' '}
									gyűjtése, a honlapot Tamás fia,{' '}
									<b>
										<a href='/person/1982-04-23-Parditka-András'>Andris</a>
									</b>{' '}
									készítette –{' '}
									<b>
										{formatNumber(Object.keys(getData().personsById).length)}
									</b>{' '}
									személy és{' '}
									<b>
										{formatNumber(Object.keys(getData().couplesById).length)}
									</b>{' '}
									család ismert,{' '}
									<a href='/clouds'>
										<b>{formatNumber(getData().clouds?.length)}</b> felhőben
									</a>
									.
								</p>
								<div class='ccc_footer_remark'>
									<p>
										Egyes személyek adatai hiányosak, ezért esetükben becsült
										adatokból dolgoztam. A kérdőjellel{' '}
										<span class={_.ccc_unknown}>(?)</span> jelölt adatok –
										becsült adatok.
									</p>
									<p>
										Az átlagos életkor az első házasságkötés időpontjában
										nőknél:{' '}
										<b>
											<Slot
												get={() =>
													(appState.data
														? getAverageFirstMarriageAge(appState.data, false)
														: 0) + ''
												}
											/>{' '}
											év
										</b>
										, férfiaknál:{' '}
										<b>
											<Slot
												get={() =>
													(appState.data
														? getAverageFirstMarriageAge(appState.data, true)
														: 0) + ''
												}
											/>{' '}
											év
										</b>
										. A legmagasabb föltételezett életkor:{' '}
										<b>{formatNumber(MAX_AGE)} év</b>. Az{' '}
										<a href='/average-age'>átlagos életkorok itt találhatók</a>.
									</p>
								</div>
								<h2>Visszajelzés</h2>
								<p>
									Hibát találtál? Hiányzik valaki? Véleményed van? Egy ötlet
									jutott eszedbe? Ma van a szülinapom?
								</p>
								<div class={_.ccc_tiles__centered}>
									<a
										class={_.ccc_button__rounded}
										href={andrisEmail(
											'A családfával kapcsolatban',
											'És akkor eszembe jutottál...',
										)}
									>
										<Icon svg='<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="currentColor" d="m8 2.748l-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385c.92 1.815 2.834 3.989 6.286 6.357c3.452-2.368 5.365-4.542 6.286-6.357c.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15"/></svg>' />{' '}
										Írd meg Andrisnak!
									</a>
								</div>
							</>
						),
					)}
					else={() => (
						<p>
							A Parditka családfa <b>Parditka Tamás</b> gyűjtése, a Percze
							családfa <b>Lazsánné Hegymegi Ilona</b> gyűjtése, a honlapot Tamás
							fia, <b>Andris</b> készítette.
						</p>
					)}
				/>
			</div>
		</footer>
	)
})
